'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function Footer() {
  const router = useRouter();

  const redirectToHome = () => {
    router.push('/');
  };

  return (
    <div className="foot-container">
      <div className="horizontal-layout">
        <div className="address">
          <div className="foot-logo">
            <a href="#" onClick={(e) => { e.preventDefault(); redirectToHome(); }}>
              <img src="/footer-logo.png" alt="Fabdigit" />
            </a>
          </div>
          <div className="title">Headquarters</div>
          <p>
          11501 DUBLIN BLVD STE 200 DUBLIN, CA 94568, USA
          </p>
        </div>

        <div className="services">
          <div className="title">Manufacturing Services</div>
          <ul>
            <li><Link href="/services/cnc-machining/">CNC Machining</Link></li>
            <li><Link href="/services/sheet-metal-fabrication/">Sheet Metal</Link></li>
            <li><Link href="/services/injection-molding/">Injection Molding</Link></li>
            <li><Link href="/services/3d-printing/">3D Printing</Link></li>
            <li><Link href="/services/pcb-pcba/">PCB / PCBA</Link></li>
            <li><Link href="/services/vacuum-casting/">LiB Consultancy</Link></li>
          </ul>
        </div>

        <div className="industries">
          <div className="title">Service Industries</div>
          <ul>
            <li><Link href="/industries/electronics/">Electronics</Link></li>
            <li><Link href="/industries/aerospace/">Aerospace</Link></li>
            <li><Link href="/industries/automotive/">Automotive</Link></li>
            <li><Link href="/industries/consumer-products/">Consumer Products</Link></li>
            <li><Link href="/industries/pharmaceutical/">Pharmaceutical</Link></li>
            <li><Link href="/industries/industrial/">Industrial</Link></li>
          </ul>
        </div>

        <div className="company">
          <div className="title">About Us</div>
          <ul>
            <li><Link href="/company/our-story/">Our Story</Link></li>
            <li><Link href="/company/contact-us/">Contact Us</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer">
        <p>
          © FABDIGIT, Inc All Rights Reserved   
        </p>
        <p id="webterms"><Link href="/legal/user-terms-conditions/">Terms & Conditions</Link> | <Link href="/legal/privacy-policy/">Privacy Policy</Link></p>
      </div>
    </div>
  );
}

